import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49bafcf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]
const _hoisted_3 = ["data-js"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_step_item_title = _resolveComponent("step-item-title")!
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_step_item_title, { "is-optional": true }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.phone.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.phone.help')), 9, _hoisted_2)
    ]),
    _createElementVNode("label", {
      ref: "refLabelPhoneSelection",
      class: "m-input_phone phone-selection",
      "data-js": `{'c-input-phone': {defaultCountry: '${_ctx.defaultCountry}'}}`,
      "data-phonenumber": ""
    }, [
      _createElementVNode("input", {
        ref: "refInputPhoneSelection",
        type: "tel",
        value: _ctx.modelValue,
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onInputPhoneValidation: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInputPhoneValidation && _ctx.onInputPhoneValidation(...args)))
      }, null, 40, _hoisted_4)
    ], 8, _hoisted_3),
    (_ctx.displayError && _ctx.modelValue.length)
      ? (_openBlock(), _createBlock(_component_joy_form_error, {
          key: 0,
          "no-html-error-text": _ctx.$msg('profile.creation.completion.wizard.details.phone.invalid')
        }, null, 8, ["no-html-error-text"]))
      : _createCommentVNode("", true)
  ]))
}